var $916bbfaaead96dd6$exports = {};
$916bbfaaead96dd6$exports = {
    "info": `\u{C815}\u{BCF4}`,
    "negative": `\u{C624}\u{B958}`,
    "positive": `\u{C131}\u{ACF5}`
};


export {$916bbfaaead96dd6$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
